import { render, staticRenderFns } from "./FlexAlert.vue?vue&type=template&id=02f475f3&scoped=true"
import script from "./FlexAlert.vue?vue&type=script&lang=js"
export * from "./FlexAlert.vue?vue&type=script&lang=js"
import style0 from "./FlexAlert.vue?vue&type=style&index=0&id=02f475f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f475f3",
  null
  
)

export default component.exports